import { Helmet } from 'react-helmet-async';
import {
  SITE_URL,
  ORG_LOGO_URL,
  organizationJsonLd,
  websiteJsonLd,
  DEFAULT_OG_IMAGE,
} from '../../seo/siteSeo';

/** Global social defaults + Organization/WebSite JSON-LD. Per-page tags live in PageSEO. */
export default function SiteBranding() {
  return (
    <Helmet>
      <meta name="application-name" content="Databiqs" />
      <meta property="og:site_name" content="Databiqs" />
      <meta property="og:image" content={DEFAULT_OG_IMAGE} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:image" content={DEFAULT_OG_IMAGE} />
      <link rel="logo" href={ORG_LOGO_URL} />
      <script type="application/ld+json">{JSON.stringify(organizationJsonLd)}</script>
      <script type="application/ld+json">{JSON.stringify(websiteJsonLd)}</script>
      <link rel="alternate" type="application/xml" href={`${SITE_URL}/sitemap.xml`} title="Sitemap" />
    </Helmet>
  );
}
